/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./location/platform_location'));
__export(require('./location/location_strategy'));
__export(require('./location/hash_location_strategy'));
__export(require('./location/path_location_strategy'));
__export(require('./location/location'));
//# sourceMappingURL=location.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/@angular/common/src/location.js
 ** module id = 434
 ** module chunks = 0
 **/